import { Alert, AlertDescription, Button } from '@mgrvtechgroup/admin-ds';
import { CircleAlertIcon } from 'lucide-react';

const count = (value: number) => value.toLocaleString('ko-KR');

/**
 * "더 보기"로 이어 붙이는 목록의 하단 — 불러온 수/전체 수와 다음 페이지 버튼.
 * 다음 페이지가 실패해도 이미 불러온 행은 그대로 두고 여기서만 알린다.
 * 서버 cursor가 더는 유효하지 않으면(409·422) 같은 요청을 되풀이하지 않고 `restart`로 처음부터 다시 읽게 한다.
 */
export function LoadMoreFooter({
  label,
  loaded,
  total,
  hasMore,
  isFetching,
  errorMessage,
  restart,
  onLoadMore,
  unit = '건',
}: {
  /** 스크린리더용 목록 이름 — "대사 항목" */
  label: string;
  loaded: number;
  total: number;
  hasMore: boolean;
  isFetching: boolean;
  errorMessage?: string | null;
  restart?: { label: string; onClick: () => void } | null;
  onLoadMore: () => void;
  unit?: string;
}) {
  return (
    <div role="group" aria-label={`${label} 더 보기`} className="flex flex-col gap-3 py-3">
      {errorMessage ? (
        <Alert variant="warning" icon={CircleAlertIcon}>
          <AlertDescription>{errorMessage}</AlertDescription>
        </Alert>
      ) : null}
      <div className="flex flex-wrap items-center gap-3">
        <p className="caption text-muted-foreground tabular-nums" role="status" aria-live="polite">
          {count(loaded)}
          {unit} / 전체 {count(total)}
          {unit} 표시
        </p>
        {errorMessage && restart ? (
          <Button variant="outline" onClick={restart.onClick}>
            {restart.label}
          </Button>
        ) : hasMore || errorMessage ? (
          <Button variant="outline" loading={isFetching} onClick={onLoadMore}>
            {errorMessage ? '다시 시도' : '더 보기'}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
